import "../styles/Popup.css";

const Popup = (props) => {
  return (
    <div className="lmj-popup">
      <div className="lmj-popup-inner">
        <button className="lmj-close-btn">✖</button>
        {props.content}
      </div>
    </div>
  );
};

export default Popup;
